import mascot from '@/features/experiences/pages/PlannerLandingPage/assets/mascot.png';
import { Flex, Icon, Image, Text } from '@/ui';
import { SidebarIconChip } from '../SidebarKit';
import { useCustomizeMode } from '../useCustomizeMode';
import { useCustomizeOptions } from '../useCustomizeOptions';

export const CustomizeHome = () => {
  const { setActiveControl } = useCustomizeMode();
  const homeOptions = useCustomizeOptions().filter(
    (option) => !option.hideFromHome
  );

  return (
    <Flex direction="column" flex={1} gap={3} minH={0} overflowY="auto" p={4}>
      {/* The asset carries ~20% transparent padding below the calendar. */}
      <Image alignSelf="center" alt="" mb={-2} src={mascot} w="120px" />

      <Text
        color="ink.strong"
        fontFamily="display"
        fontSize="2xl"
        letterSpacing="-0.02em"
        lineHeight={1.15}
        mb={1}
        textAlign="center"
      >
        What would you like to customize?
      </Text>

      {homeOptions.map(({ id, icon, label, description }) => (
        <Flex
          _active={{ transform: 'scale(0.99)' }}
          align="flex-start"
          as="button"
          bg="white"
          border="1.5px solid"
          borderColor="line.DEFAULT"
          borderRadius="ah-xl"
          cursor="pointer"
          gap={3}
          key={id}
          p={3.5}
          textAlign="left"
          transition="border-color 0.14s, box-shadow 0.14s, transform 0.12s"
          _hover={{
            borderColor: 'magicPurple.500',
            boxShadow: '0 8px 20px -12px rgba(93,63,246,0.5)',
          }}
          onClick={() => setActiveControl(id)}
        >
          <SidebarIconChip size="40px" variant="purple">
            <Icon
              as={icon as React.ElementType}
              boxSize="20px"
              color="magicPurple.600"
            />
          </SidebarIconChip>

          <Flex direction="column" minW={0}>
            <Text
              color="ink.strong"
              fontFamily="display"
              fontSize="lg"
              lineHeight={1.1}
            >
              {label}
            </Text>
            <Text
              color="ink.soft"
              fontSize="ah-control"
              lineHeight={1.4}
              mt={1}
            >
              {description}
            </Text>
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};
